module.exports = __webpack_public_path__ + "img/chivas-main-bg.3b8c52b7.jpg";